import { TripStatusReportDto } from '@/__generated';
import { dateTimeDisplayFormat } from '@/config';
import { TripStatusType } from '@/constants';
import { scales } from 'chart.js';
import { sortBy } from 'lodash';
import moment from 'moment';
import React from 'react';

const headers = ['No.', 'Trip Name', 'Bus No.', 'Departure', 'Source', 'Destination', 'Stops', 'Status', 'Recurrence'];
const getRecurrenceText = (recurrenceNumDays: number[]) => {
  if (recurrenceNumDays?.length === 7) {
    return 'Daily';
  }
  const days = sortBy(recurrenceNumDays || [], x => x);
  return days
    .map(d => moment().day(d))
    .map(x => x.format('dd'))
    .join(', ');
};

const getTripStatusColor = status => {
  if (status === TripStatusType.CheckedIn) {
    return '#ffc107';
  }
  if (status === TripStatusType.Boarding) {
    return '#8bc34a';
  }
  if ([TripStatusType.Delayed, TripStatusType.Cancelled].includes(status)) {
    return '#e91e63';
  }
  return '';
};

const scale = (value: number, ratio: number) => Math.ceil(value * ratio);
type Props = { title: string; trips: TripStatusReportDto[]; ratio: number };

const TripPageItem = ({ trips, title, ratio }: Props) => {
  return (
    <div className="page">
      <div className="title" style={{ fontSize: scale(30, ratio) }}>
        {title}
      </div>
      <div className="content" style={{ fontSize: scale(16, ratio) }}>
        <table>
          <thead>
            <tr>
              {headers.map(h => {
                return <th key={h}>{h} </th>;
              })}
            </tr>
          </thead>
          <tbody>
            {trips.map((trip, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{trip.tripName}</td>
                  <td>{trip.busNo}</td>
                  <td>{dateTimeDisplayFormat.originTimeOnly(trip.departureDatetime)}</td>
                  <td>{trip.sourceStation}</td>
                  <td>{trip.destinationStation}</td>
                  <td>{trip.noOfStops}</td>
                  <td style={{ backgroundColor: getTripStatusColor(trip.status) }}>{TripStatusType.__getValue(trip.status)}</td>
                  <td>{getRecurrenceText(trip.recurrenceNumDays || [])}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TripPageItem;
